module.exports = {"name":"powerUpSuggestions","meta":{"description":"Displays a text message \"Enable 'Power-Up Name' to see more information\" when a user attaches a URL that falls within the experiment. E.g., Dropbox."},"audiences":["allMembers"],"experimentAllocation":0.1,"defaultWeight":1,"experimentVersion":"v1","defaults":{"maxDismissalCount":3},"autoTrack":true,"variations":[{"name":"fiveDismissals","weight":1,"values":{"maxDismissalCount":5}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/powerUpSuggestions.json
// module id = eBu/
// module chunks = 13